"use strict";

import { dateToISOString, ISOStringToDate } from "@elements/date-utils";
import { setDefaultDate } from "./datepicker";
import onInitModulesInsScope from "./onInitModulesInScope";

/**
 * Date controller for content-map-lift-list (Area 3): yesterday/today/tomorrow
 * quick-nav + the "Datum wählen" date-picker, all submitting through the same
 * ajax-form (see lift-rows swap). The active date is only ever shown as a
 * plain dd.mm.yyyy readout; "Gestern"/"Morgen" are recomputed relative to
 * whichever date is currently active, so repeated clicks step one day at a
 * time and picking an arbitrary date re-centers the quick-nav around it.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

function todayUTC() {
    let now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
}

function addDays(date, days) {
    return new Date(date.getTime() + days * DAY_MS);
}

function formatDisplay(date) {
    let dd = String(date.getUTCDate()).padStart(2, '0');
    let mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    return dd + '.' + mm + '.' + date.getUTCFullYear();
}

function getActiveDate($form) {
    let iso = $form.find('.js-datepicker__alt-field').val();
    return iso ? ISOStringToDate(iso) : todayUTC();
}

function updateDateDisplay($form, activeDate) {
    $form.find('.js-date-controller__text').text(formatDisplay(activeDate));
}

function updateQuickNav($form, activeDate) {
    // "Gestern" is disabled while the active date is today (mirrors the
    // template's default-disabled markup for that same initial state) and
    // re-enabled the moment the active date moves away from it.
    $form.find('.js-date-controller__prev')
        .attr('data-date', dateToISOString(addDays(activeDate, -1), false))
        .prop('disabled', isToday(activeDate));
    $form.find('.js-date-controller__next').attr('data-date', dateToISOString(addDays(activeDate, 1), false));
}

function isToday(date) {
    return date.getTime() === todayUTC().getTime();
}

function submitDate($form, date) {
    let $datepicker = $form.find('.js-datepicker');
    let iso = dateToISOString(date, false);

    $datepicker.find('.js-datepicker__alt-field').val(iso).trigger('change');
}

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        // The date-controller form lives outside .js-ajax-form__result, so it
        // only ever appears in the initial full-page scope, never in a
        // swapped-in fragment — this naturally binds once, like ticket-filter.js's
        // "filter UI lives outside the result container" setup.
        $scope.find('.js-date-controller__form').each(function () {
            let $form = $(this);
            let $datepicker = $form.find('.js-datepicker');

            let activeDate = getActiveDate($form);
            updateDateDisplay($form, activeDate);
            // Pill stays empty/placeholder, but the calendar popup should
            // still open on the right month — see setDefaultDate()'s comment.
            setDefaultDate($datepicker, activeDate);

            $form.find('.js-date-controller__prev, .js-date-controller__next').on('click', function () {
                submitDate($form, ISOStringToDate($(this).attr('data-date')));
            });

            // The hidden alt-field carries the selected value; the visible
            // pill only ever shows its "Datum wählen" placeholder — jQuery UI
            // writes the formatted date into it before firing this, so clear
            // it back out on every change (calendar pick or quick-nav click).
            //
            // Picking a day directly from the calendar popup writes a full
            // ISO datetime (via datepicker.js's onSelect) rather than the
            // date-only ISO submitDate() uses for the quick-nav buttons —
            // normalize it here so the ajax-form's URL param (and the date
            // this form submits) always stays a plain Y-m-d, matching what
            // OpeningHoursController::getRequestedDate() expects.
            $datepicker.find('.js-datepicker__alt-field').on('change', function () {
                let $altField = $(this);
                let normalized = dateToISOString(ISOStringToDate($altField.val()), false);
                if ($altField.val() !== normalized) {
                    $altField.val(normalized);
                }
                $datepicker.find('.js-datepicker__input').val('');
            });

            $form.closest('.js-ajax-form').on('success.ajax-form', function () {
                let activeDate = getActiveDate($form);
                updateDateDisplay($form, activeDate);
                updateQuickNav($form, activeDate);
                setDefaultDate($datepicker, activeDate);
            });
        });
    });
}
